module.exports = __webpack_public_path__ + "media/bgmusic-festival.7e5588c5.mp3";